<h2 mat-dialog-title class="dialog-title">Le groupe a été créé avec succès</h2>

<mat-dialog-content class="dialog-content">
  <section class="section">
    <div class="section-header">
      <mat-icon>group_work</mat-icon>
      <span>Informations du groupe</span>
    </div>

    <div class="kv">
      <div class="label">Group ID</div>
      <div class="value">
        <code>{{ data.creationResult.group.name }}</code>
        <button mat-icon-button matTooltip="Copier" (click)="copy(data.creationResult.group.name)">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>

    <div class="kv">
      <div class="label">Group Password</div>
      <div class="value">
        <code>{{ data.creationResult.group.password }}</code>
        <button mat-icon-button matTooltip="Copier" (click)="copy(data.creationResult.group.password)">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>
  </section>

  <div class="grid">
    <section class="section">
      <div class="section-header">
        <mat-icon>supervisor_account</mat-icon>
        <span>Utilisateur parent</span>
      </div>

      <div class="kv">
        <div class="label">Login</div>
        <div class="value">
          <code>{{ data.creationResult.parent.user.login }}</code>
          <button mat-icon-button matTooltip="Copier" (click)="copy(data.creationResult.parent.user.login)">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </div>

      <div class="kv">
        <div class="label">Mot de passe</div>
        <div class="value">
          <code>{{ data.creationResult.parent.password }}</code>
          <button mat-icon-button matTooltip="Copier" (click)="copy(data.creationResult.parent.password)">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="section-header">
        <mat-icon>person</mat-icon>
        <span>Utilisateur principal</span>
      </div>

      <div class="kv">
        <div class="label">Login</div>
        <div class="value">
          <code>{{ data.creationResult.mainUser.user.login }}</code>
          <button mat-icon-button matTooltip="Copier" (click)="copy(data.creationResult.mainUser.user.login)">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </div>

      <div class="kv">
        <div class="label">Mot de passe</div>
        <div class="value">
          <code>{{ data.creationResult.mainUser.password }}</code>
          <button mat-icon-button matTooltip="Copier" (click)="copy(data.creationResult.mainUser.password)">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </div>
    </section>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button color="warn" (click)="onClose()">Fermer</button>
</mat-dialog-actions>
